import React, { useContext, useEffect, useState, useRef } from "react";
import axios from "axios";
import ReactMarkdown from "react-markdown";
import * as LocaleUtils from "../../../lib/util/LocaleUtils";
import { LocaleContext } from "../../../lib/util/LocaleUtils";
import InfoOverlay from "../../../components/state/InfoOverlay/InfoOverlay";
import { isFiveKeysTheme } from "../../../lib/util/ThemeUtils";

const locales = require("../../../lib/locale");

export interface LegalCopyProps {
	id: string;
}

const attemptCopyLoad = async (id: string, code: string): Promise<Buffer> => {
	const res = await axios(`/legal/${id}.${code}.md?t=${Date.now()}`);
	if (!res.data.toString().includes("@copy")) {
		throw new Error(`Invalid '${id}' loaded for '${code}'`);
	}
	return res.data;
};

const LegalCopy = (props: LegalCopyProps) => {
	const { id } = props;
	const isFiveKeys = useRef(isFiveKeysTheme());

	const languageContext = useContext(LocaleContext);

	const [source, setSource] = useState<string | null>(null);

	const load = async (code: string) => {
		const computedId = isFiveKeys.current && id ? `five-keys-${id}` : id;
		let res = null;

		try {
			res = await attemptCopyLoad(computedId, code);
		} catch {
			// then try just first part
			try {
				res = await attemptCopyLoad(computedId, code.split("-")[0]);
			} catch (error) {
				console.warn(`No '${computedId}' policy for '${code}'`, error);
				res = await attemptCopyLoad(
					computedId,
					LocaleUtils.DEFAULT_LOCALE.code,
				);
			}
		}
		setSource(res.toString().replace(/<!--.*-->/gi, ""));
	};

	const code = languageContext?.code ?? LocaleUtils.DEFAULT_LOCALE.code;

	useEffect(() => {
		load(code);
		// eslint-disable-next-line
	}, [code]);

	return (
		<div className={"Legal__content"}>
			{source ? (
				<ReactMarkdown>{source}</ReactMarkdown>
			) : (
				<InfoOverlay type={"loading"} />
			)}
		</div>
	);
};

export default React.memo(LegalCopy);
